import CustomModal from 'components/global/CustomModal'
import React, { useEffect, useState } from 'react'
import NoAgreements from '../ModalCotent/Agreements/NoAgreements'
import CustomModalFooter from 'components/global/CustomModalFooter'
import AgreementsFound from '../ModalCotent/Agreements/AgreementsFound'
import AddAgreement from '../ModalCotent/Agreements/AddAgreement'
import { useGetAgreements } from 'api/Agreements/Agreeements'
import Spinner from 'components/Spinner'
import { AgreementResp } from 'types/agreement/agreement'

interface AgreementsModalProps {
  modalOpen: boolean
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  type: 'event' | 'league' | 'class'
  entityId: string
  selectedAgreementsIds: string[]
  setSelectedAgreementsIds: (state: string[]) => void
}

const AgreementsModal: React.FC<AgreementsModalProps> = ({
  modalOpen,
  setModalOpen,
  type,
  entityId,
  selectedAgreementsIds,
  setSelectedAgreementsIds,
}) => {
  const [openAddAgreementModal, setOpenAddAgreementModal] =
    useState<boolean>(false)
  const { data, isLoading, isFetching, refetch } = useGetAgreements(
    type === 'event' ? { eventId: entityId } : 
    type === 'league' ? { leagueId: entityId } : 
    { classId: entityId }
  )
  const [selectedAgreement, setSelectedAgreement] = useState<AgreementResp>()

  const handleAddAgreement = () => {
    setSelectedAgreement(undefined)
    setOpenAddAgreementModal(true)
  }

  const hanldeSubmit = () => {
    setModalOpen(false)
  }

  useEffect(() => {
    refetch()
  }, [entityId])

  return (
    <>
      <CustomModal
        openModal={modalOpen}
        closeModal={setModalOpen}
        title="Agreements"
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-center"
            btnText="Add new agreement,Save"
            closeModal={handleAddAgreement}
            onSubmit={hanldeSubmit}
          />
        }
      >
        <div className="h-20">
          {isLoading || isFetching ? (
            <div className="h-full flex justify-center items-center">
              <Spinner />
            </div>
          ) : (
            <>
              {data.length ? (
                <AgreementsFound
                  agreements={data}
                  selectedAgreement={selectedAgreement}
                  setSelectedAgreement={setSelectedAgreement}
                  setOpenAddAgreementModal={setOpenAddAgreementModal}
                  selectedAgreementsIds={selectedAgreementsIds}
                  setSelectedAgreementsIds={setSelectedAgreementsIds}
                />
              ) : (
                <NoAgreements />
              )}
            </>
          )}
        </div>
      </CustomModal>

      {openAddAgreementModal && (
        <AddAgreement
          type={type}
          openModal={openAddAgreementModal}
          setOpenModal={setOpenAddAgreementModal}
          entityId={entityId}
          selectedAgreement={selectedAgreement}
          setSelectedAgreement={setSelectedAgreement}
        />
      )}
    </>
  )
}

export default AgreementsModal
